export const validatePassword = (password) => {
  const errors = []
  const requirements = {
    length: false,
    lowercase: false,
    uppercase: false,
    digit: false,
    symbol: false
  }

  if (password.length < 12) {
    errors.push('Password must be at least 12 characters long')
  } else {
    requirements.length = true
  }

  if (!/[a-z]/.test(password)) {
    errors.push('Password must contain at least one lowercase letter')
  } else {
    requirements.lowercase = true
  }

  if (!/[A-Z]/.test(password)) {
    errors.push('Password must contain at least one uppercase letter')
  } else {
    requirements.uppercase = true
  }

  if (!/\d/.test(password)) {
    errors.push('Password must contain at least one digit')
  } else {
    requirements.digit = true
  }

  if (!/[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~`]/.test(password)) {
    errors.push('Password must contain at least one symbol')
  } else {
    requirements.symbol = true
  }

  const isValid = errors.length === 0

  return {
    isValid,
    errors,
    requirements
  }
}

export const getPasswordStrength = (password) => {
  const { requirements } = validatePassword(password)
  const metRequirements = Object.values(requirements).filter(Boolean).length
  
  if (metRequirements < 2) return { strength: 'weak', score: 1 }
  if (metRequirements < 4) return { strength: 'medium', score: 2 }
  if (metRequirements === 4) return { strength: 'strong', score: 3 }
  if (metRequirements === 5) return { strength: 'excellent', score: 4 }
  
  return { strength: 'weak', score: 1 }
}
